/* lae-mesure.js — le traceur de mesure de litaeau.fr (thème). Source : mesure/traceur/lae-mesure.js.
 *
 * Ce qu'il mesure, horodaté à la milliseconde : la page vue (source, appareil, performances), le défilement, le
 * temps de visibilité de chaque section, chaque clic (position pour les cartes de chaleur, clics de rage, clics
 * morts), les champs de formulaire touchés (JAMAIS leur valeur), les étapes du configurateur, la 3D, les vidéos,
 * le panier, la recherche, les erreurs JavaScript, les Web Vitals réels, et l'enregistrement de la visite (rrweb)
 * pour la rejouer en vidéo dans le tableau de bord local.
 *
 * 🛑 Consentement : RIEN ne démarre tant que le visiteur n'a pas accepté la mesure (API Customer Privacy de
 *    Shopify, bandeau de la boutique). S'il refuse ou retire son accord, le traceur s'arrête et n'écrit plus rien.
 * 🛑 Vie privée : aucun champ saisi n'est lu (rrweb masque toutes les saisies), aucun nom, aucun e-mail, aucune IP
 *    (le récepteur ne la garde pas). Visiteur et session sont des identifiants ALÉATOIRES.
 * 🛑 Robots et nos propres sondes (Playwright : navigator.webdriver) ne sont pas mesurés — sauf le mode test
 *    (localStorage lae_mesure_test = 1), réservé aux essais de bout en bout.
 * Coût : ce fichier seul (quelques Ko, chargé en `defer`) ; l'enregistreur rrweb (77 Ko) n'est chargé qu'après
 * consentement, quand le navigateur est inactif.
 */
(function () {
  'use strict';
  var C = window.LAE_MESURE || {};
  if (!C.url || window.__laeMesure) return;
  window.__laeMesure = true;

  var LS = (function () { try { var k = '__lae_t'; localStorage.setItem(k, '1'); localStorage.removeItem(k); return localStorage; } catch (e) { return null; } })();
  var lsGet = function (k) { try { return LS && LS.getItem(k); } catch (e) { return null; } };
  var lsSet = function (k, v) { try { LS && LS.setItem(k, v); } catch (e) { /* stockage bloqué : sans importance */ } };
  var mode_test = lsGet('lae_mesure_test') === '1';
  if (navigator.webdriver && !mode_test) return;                         // robots pilotés, nos sondes
  if (/bot|crawl|spider|headless|lighthouse|pagespeed/i.test(navigator.userAgent) && !mode_test) return;
  if (window.Shopify && window.Shopify.designMode) return;               // éditeur de thème
  /* 01/10 : le script de l'enregistreur (un fichier du thème, ~77 Ko) se TÉLÉCHARGE dès l'arrivée. Rien ne s'exécute
     et rien ne part avant le consentement — mais, une fois l'accord donné, l'enregistrement démarre sans attendre le
     réseau. Mesuré : sur la page lourde du configurateur, quittée en 5 s, la photo n'avait pas toujours le temps de partir. */
  if (C.rrweb && C.replay !== false) {
    try { var pre = document.createElement('link'); pre.rel = 'preload'; pre.as = 'script'; pre.href = C.rrweb; document.head.appendChild(pre); } catch (e) {}
  }
  if (/[?&]lae_interne=1\b/.test(location.search)) lsSet('lae_interne', '1');
  if (/[?&]lae_interne=0\b/.test(location.search)) lsSet('lae_interne', '0');

  var T0 = Date.now();
  var perfNow = function () { return (window.performance && performance.now) ? performance.now() : Date.now() - T0; };
  var now = function () { return Math.round((performance.timeOrigin || T0) + perfNow()); };
  var rnd = function (n) {
    var a = new Uint8Array(n || 12), s = '';
    (window.crypto || window.msCrypto).getRandomValues(a);
    for (var i = 0; i < a.length; i++) s += ('0' + a[i].toString(16)).slice(-2);
    return s;
  };
  var cookie = function (k) { var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : null; };
  var setCookie = function (k, v, jours) {
    document.cookie = k + '=' + encodeURIComponent(v) + '; path=/; max-age=' + Math.round(jours * 86400) + '; SameSite=Lax; Secure';
  };

  var actif = false;       // consentement obtenu et mesure en cours
  var visiteur, session, vue = rnd(8), file = [], minuterie = null, rr = null;
  var interne = lsGet('lae_interne') === '1';

  function chemin() { return location.pathname; }

  // ── envoi ────────────────────────────────────────────────────────────────────────────────────
  function empiler(type, d) {
    if (!actif) return;
    file.push({ t: type, ts: now(), p: chemin(), vue: vue, d: d });
    // la vue elle-même part vite (1,5 s) : une visite qui repart aussitôt doit exister dans les chiffres
    if (file.length >= 40) vider(false); else if (!minuterie) minuterie = setTimeout(function () { vider(false); }, type === 'page' ? 1500 : 5000);
  }
  function vider(fin) {
    clearTimeout(minuterie); minuterie = null;
    if (!file.length || !visiteur) return;
    var lot = file.splice(0, file.length);
    var corps = JSON.stringify({ v: visiteur, s: session, o: 'theme', ev: lot });
    try {
      // 🛑 sendBeacon peut REFUSER (réserve de 64 Ko partagée par la page, que les envois de Shopify remplissent
      //    à la sortie) : mesuré le 29/09, la sortie se perdait en parcours réel. On bascule alors sur fetch.
      var parti = fin && navigator.sendBeacon && corps.length < 60000 && navigator.sendBeacon(C.url + '/e', new Blob([corps], { type: 'text/plain' }));
      if (!parti) {
        fetch(C.url + '/e', { method: 'POST', body: corps, keepalive: corps.length < 60000, mode: 'cors',
          headers: { 'Content-Type': 'text/plain' }, credentials: 'omit' }).catch(function () {});
      }
    } catch (e) { /* la mesure ne doit jamais casser la page */ }
  }

  // ── identifiants ──────────────────────────────────────────────────────────────────────────────
  function identifiants() {
    // Le visiteur Shopify (_shopify_y) permet de relier la visite aux étapes du paiement vues par le pixel.
    visiteur = cookie('_shopify_y') || cookie('lae_v') || lsGet('lae_v') || rnd(12);
    visiteur = String(visiteur).replace(/[^A-Za-z0-9_-]/g, '').slice(0, 64);
    if (visiteur.length < 6) visiteur = rnd(12);
    lsSet('lae_v', visiteur); setCookie('lae_v', visiteur, 395);
    var s = null; try { s = JSON.parse(lsGet('lae_s') || 'null'); } catch (e) { s = null; }
    var neuve = !s || !s.id || (Date.now() - (s.dernier || 0)) > 30 * 60 * 1000;
    session = neuve ? rnd(10) : s.id;
    lsSet('lae_s', JSON.stringify({ id: session, dernier: Date.now(), debut: neuve ? Date.now() : s.debut, n: neuve ? 1 : (s.n || 0) + 1 }));
    setCookie('lae_s', session, 1 / 48);     // 30 min, lu par le pixel de paiement
    return neuve;
  }
  function toucherSession() {
    try { var s = JSON.parse(lsGet('lae_s') || 'null'); if (s && s.id === session) { s.dernier = Date.now(); lsSet('lae_s', JSON.stringify(s)); } } catch (e) {}
    setCookie('lae_s', session, 1 / 48);
  }

  // ── contexte de la page vue ───────────────────────────────────────────────────────────────────
  function appareil() {
    var w = Math.min(screen.width || innerWidth, innerWidth);
    if (/iPad|Tablet/i.test(navigator.userAgent) || (w >= 600 && w < 1024 && 'ontouchstart' in window)) return 'tablette';
    return w < 750 ? 'mobile' : 'ordinateur';
  }
  function source() {
    var q = new URLSearchParams(location.search), r = document.referrer, h = '';
    try { h = r ? new URL(r).hostname : ''; } catch (e) { h = ''; }
    var s = { ref: h && h !== location.hostname ? h : '', utm_source: q.get('utm_source') || '', utm_medium: q.get('utm_medium') || '',
      // gbraid / wbraid : ce que Google Ads met à la place de gclid sur iPhone (25/10) — sans eux, un clic d'annonce
      // venu d'un iPhone se lirait « recherche » ou « direct ».
      utm_campaign: q.get('utm_campaign') || '', gclid: (q.has('gclid') || q.has('gbraid') || q.has('wbraid')) ? 1 : 0,
      fbclid: q.has('fbclid') ? 1 : 0 };
    var c = 'direct';
    if (s.gclid || /cpc|ppc|paid/i.test(s.utm_medium)) c = 'payant';
    else if (/google\.|bing\.|duckduckgo|qwant|ecosia|yahoo|yandex|brave|startpage/.test(h)) c = 'recherche';
    else if (/chatgpt|openai|perplexity|claude\.ai|gemini|copilot/.test(h) || /chatgpt|perplexity/i.test(s.utm_source)) c = 'ia';
    else if (/facebook|instagram|pinterest|linkedin|tiktok|youtube|t\.co|twitter|x\.com/.test(h) || s.fbclid) c = 'social';
    else if (/mail|newsletter/i.test(s.utm_medium)) c = 'email';
    else if (h && h !== location.hostname) c = 'site_referent';
    s.canal = c;
    return s;
  }
  function contextePage() {
    var n = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    var sh = window.Shopify || {};
    return {
      titre: (document.title || '').slice(0, 140), source: source(), appareil: appareil(), interne: interne ? 1 : 0,
      vw: innerWidth, vh: innerHeight, dpr: window.devicePixelRatio || 1, langue: navigator.language,
      tactile: ('ontouchstart' in window) ? 1 : 0, connexion: (navigator.connection && navigator.connection.effectiveType) || '',
      doc_h: document.documentElement.scrollHeight, gabarit: C.gabarit || '', theme: sh.theme && sh.theme.id || C.theme || '',
      devise: sh.currency && sh.currency.active || '', nav: n.type || '',
      // visite d'ESSAI : mode test, ou aperçu d'un thème non publié (l'équipe qui vérifie une copie) — écartée par défaut
      test: (mode_test || (sh.theme && sh.theme.role && sh.theme.role !== 'main')) ? 1 : 0,
      perf: n.responseStart ? { ttfb: Math.round(n.responseStart), dom: Math.round(n.domContentLoadedEventEnd || 0),
        charge: Math.round(n.loadEventEnd || 0), transfert: n.transferSize || 0 } : null,
    };
  }

  // ── défilement ────────────────────────────────────────────────────────────────────────────────
  var defil = { max: 0, maxPx: 0, paliers: {} };
  function mesurerDefilement() {
    var h = document.documentElement.scrollHeight - innerHeight;
    var y = window.scrollY || pageYOffset || 0;
    var pct = h > 0 ? Math.min(100, Math.round(100 * y / h)) : 100;
    if (y + innerHeight > defil.maxPx) defil.maxPx = Math.round(y + innerHeight);
    if (pct > defil.max) defil.max = pct;
    [10, 25, 50, 75, 90, 100].forEach(function (p) {
      if (pct >= p && !defil.paliers[p]) { defil.paliers[p] = 1; empiler('defilement', { palier: p, ms: Math.round(perfNow()), px: Math.round(y) }); }
    });
  }

  // ── sections : temps visible, temps actif, premier affichage ──────────────────────────────────
  var sections = {}, dernierGeste = perfNow(), visibleDepuis = document.visibilityState === 'visible' ? perfNow() : null;
  function nomSection(el) {
    var id = el.id || '', c = (el.className || '').toString();
    var m = c.match(/section-([a-z0-9-]+)/) || id.match(/__([a-z0-9_-]+)$/i);
    // le TITRE visible de la section (son premier intertitre) : les clés de section générées par Shopify
    // (« 173073506013053c99 ») ne disent rien dans un tableau de bord
    var h = el.querySelector('h1, h2, h3, [class*="kicker"], [class*="eyebrow"]');
    return { id: id.replace(/^shopify-section-/, '').slice(0, 90), type: (el.getAttribute('data-section-type') || (m && m[1]) || '').slice(0, 60),
      titre: h ? (h.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 70) : '' };
  }
  function tickSections() {
    var t = perfNow(), actifGeste = (t - dernierGeste) < 15000, visible = document.visibilityState === 'visible';
    for (var k in sections) {
      var s = sections[k];
      if (s.dans && visible) {
        var dt = t - (s.depuis || t);
        s.visible_ms += dt; if (actifGeste) s.actif_ms += dt;
      }
      s.depuis = t;
    }
  }
  function observerSections() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entrees) {
      tickSections();
      entrees.forEach(function (e) {
        var s = sections[e.target.id]; if (!s) return;
        // « lue » : la section occupe au moins 40 % de l'écran, ou elle est visible à 60 % au moins (petites sections)
        var part = e.intersectionRect.height / Math.max(1, innerHeight);
        s.dans = e.isIntersecting && (part >= 0.4 || e.intersectionRatio >= 0.6);
        if (s.dans && s.premier_ms === null) s.premier_ms = Math.round(perfNow());
      });
    }, { threshold: [0, 0.1, 0.25, 0.4, 0.6, 0.8, 1] });
    var liste = document.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < liste.length; i++) {
      var el = liste[i], n = nomSection(el);
      if (/header|footer|announcement|menu-drawer/i.test(n.id)) continue;
      sections[el.id] = { id: n.id, type: n.type, titre: n.titre, ordre: i, hauteur: el.offsetHeight, haut: Math.round(el.getBoundingClientRect().top + scrollY),
        visible_ms: 0, actif_ms: 0, premier_ms: null, dans: false, depuis: perfNow() };
      io.observe(el);
    }
  }
  function bilanSections() {
    tickSections();
    var out = [];
    for (var k in sections) { var s = sections[k];
      out.push({ id: s.id, type: s.type, t: s.titre, ordre: s.ordre, h: s.hauteur, y: s.haut, vis: Math.round(s.visible_ms), act: Math.round(s.actif_ms), premier: s.premier_ms }); }
    return out;
  }

  // ── clics : position, rage, morts ─────────────────────────────────────────────────────────────
  function selecteur(el) {
    var parts = [];
    for (var n = el, i = 0; n && n.nodeType === 1 && i < 5; n = n.parentElement, i++) {
      var p = n.tagName.toLowerCase();
      if (n.id && !/^shopify-section-/.test(n.id)) { p += '#' + n.id; parts.unshift(p); break; }
      var c = (n.getAttribute('class') || '').trim().split(/\s+/).filter(function (x) { return x && x.length < 30; }).slice(0, 2);
      if (c.length) p += '.' + c.join('.');
      parts.unshift(p);
    }
    return parts.join(' > ').slice(0, 200);
  }
  function sectionDe(el) { var s = el && el.closest && el.closest('[id^="shopify-section-"]'); return s ? s.id.replace(/^shopify-section-/, '') : ''; }
  // 🛑 `[tabindex="-1"]` n'est PAS interactif : <main id="MainContent" tabindex="-1"> (cible du lien d'évitement)
  //    englobe toute la page — le compter faisait de chaque clic un clic « interactif », et aucun ne pouvait être mort.
  var INTERACTIF = 'a,button,input,select,textarea,label,summary,[role=button],[role=tab],[role=radio],[role=checkbox],[onclick],[data-cf-add],[tabindex]:not([tabindex="-1"])';
  // Réactions de la page, par section : un clic est « mort » si RIEN ne réagit dans sa section (hors changements de
  // style, que carrousels et vidéos font en continu — sans ce filtre, aucun clic n'était jamais mort), ni défilement,
  // ni changement d'adresse, dans les 700 ms.
  var clics = [], reactions = {};
  if ('MutationObserver' in window) new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var m = ms[i]; if (m.type === 'attributes' && m.attributeName === 'style') continue;
      var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      if (!el || el.closest('video,canvas')) continue;
      var s = sectionDe(el) || '_'; reactions[s] = (reactions[s] || 0) + 1;
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, characterData: true });
  function surClic(ev) {
    dernierGeste = perfNow(); nClicsTotal++;
    var el = ev.target && ev.target.nodeType === 1 ? ev.target : ev.target && ev.target.parentElement;
    if (!el) return;
    var lien = el.closest('a'), inter = el.closest(INTERACTIF);
    var x = Math.round(ev.pageX), y = Math.round(ev.pageY), t = perfNow();
    clics = clics.filter(function (c) { return t - c.t < 800; });
    clics.push({ t: t, x: x, y: y });
    var rage = clics.filter(function (c) { return Math.abs(c.x - x) < 30 && Math.abs(c.y - y) < 30; }).length >= 3;
    var champ = el.closest('input,textarea,select');
    var d = { sel: selecteur(el), txt: champ ? '' : (el.innerText || el.getAttribute('aria-label') || el.alt || '').replace(/\s+/g, ' ').trim().slice(0, 60),
      href: lien ? (lien.getAttribute('href') || '').slice(0, 200) : '', x: x, y: y, xr: +(ev.clientX / innerWidth).toFixed(4),
      vw: innerWidth, dh: document.documentElement.scrollHeight, sect: sectionDe(el), rage: rage ? 1 : 0, inter: inter ? 1 : 0 };
    if (lien && lien.hostname && lien.hostname !== location.hostname) d.sortant = lien.hostname;
    if (inter) {
      empiler('clic', d);
      // Lien interne qui va changer de page : le bilan part MAINTENANT. Au pagehide, la réserve d'envoi du navigateur
      // est déjà prise par Shopify et notre « sortie » s'y perd (mesuré le 29/09).
      var h = lien && lien.getAttribute('href') || '';
      if (lien && lien.hostname === location.hostname && h.charAt(0) !== '#' && lien.target !== '_blank' && !ev.metaKey && !ev.ctrlKey && !ev.shiftKey) etat(true);
      return;
    }
    // clic « mort » : sur un élément non interactif, et rien ne réagit dans sa section pendant 700 ms
    var sk = d.sect || '_', r0 = reactions[sk] || 0, y0 = scrollY, u0 = location.href;
    setTimeout(function () {
      d.mort = ((reactions[sk] || 0) === r0 && Math.abs(scrollY - y0) < 20 && location.href === u0) ? 1 : 0;
      empiler('clic', d);
    }, 700);
  }

  // ── formulaires : jamais la valeur, seulement le champ et le geste ────────────────────────────
  function champ(el) {
    return { nom: (el.name || el.id || el.getAttribute('aria-label') || el.type || '').slice(0, 60), type: el.type || el.tagName.toLowerCase(),
      form: el.form ? (el.form.id || el.form.getAttribute('action') || '').slice(0, 80) : '', sect: sectionDe(el) };
  }
  var focusT = {};
  function surFocus(ev) { var el = ev.target; if (!el || !el.matches || !el.matches('input,textarea,select')) return; focusT[champ(el).nom] = perfNow(); }
  function surBlur(ev) {
    var el = ev.target; if (!el || !el.matches || !el.matches('input,textarea,select')) return;
    var c = champ(el), t0 = focusT[c.nom];
    c.ms = t0 ? Math.round(perfNow() - t0) : null; c.rempli = (el.type === 'checkbox' || el.type === 'radio') ? (el.checked ? 1 : 0) : (el.value ? 1 : 0);
    empiler('champ', c);
  }
  function surSubmit(ev) {
    var f = ev.target; if (!f || f.tagName !== 'FORM') return;
    var d = { form: (f.id || f.getAttribute('action') || '').slice(0, 80), sect: sectionDe(f) };
    if (/search/.test(f.getAttribute('action') || '')) { var q = f.querySelector('[name=q]'); d.recherche = q ? (q.value || '').slice(0, 80) : ''; }
    empiler(d.recherche !== undefined ? 'recherche' : 'formulaire', d);
  }

  // ── configurateur, 3D, vidéos, copie ──────────────────────────────────────────────────────────
  // Un détail trop lourd est RÉSUMÉ (ses clés et ses valeurs simples), jamais remplacé par un objet vide.
  function court(o) {
    try {
      var s = JSON.stringify(o); if (s === undefined || s.length <= 2000) return o;
      var r = { tronque: 1 };
      if (o && typeof o === 'object') Object.keys(o).slice(0, 30).forEach(function (k) {
        var v = o[k]; if (v === null || typeof v !== 'object') r[k] = typeof v === 'string' ? v.slice(0, 80) : v;
      });
      return r;
    } catch (e) { return null; }
  }
  function surConfig(ev) { empiler('configurateur', { geste: ev.type.replace('lae:', ''), detail: court(ev.detail) }); }
  var interactions3d = 0, debut3d = null;
  function surPointer(ev) {
    dernierGeste = perfNow();
    var c = ev.target && ev.target.closest && ev.target.closest('canvas');
    if (c && c.closest('[data-lae-3d], .lae-3d, [id*="3d"], [class*="bed3d"], [class*="-3d"]')) {
      interactions3d++; if (!debut3d) { debut3d = perfNow(); empiler('trois_d', { geste: 'premier_contact', sect: sectionDe(c) }); }
    }
  }
  function brancherVideos() {
    var vs = document.querySelectorAll('video');
    for (var i = 0; i < vs.length; i++) (function (v, i) {
      if (v.__laeM) return; v.__laeM = 1;
      var nom = (v.getAttribute('data-nom') || v.currentSrc || v.getAttribute('src') || ('video-' + i)).split('/').pop().split('?')[0].slice(0, 80);
      var paliers = {};
      v.addEventListener('play', function () { empiler('video', { geste: 'lecture', nom: nom, auto: v.autoplay ? 1 : 0, sect: sectionDe(v), t: Math.round(v.currentTime) }); });
      v.addEventListener('pause', function () { if (!v.ended) empiler('video', { geste: 'pause', nom: nom, t: Math.round(v.currentTime) }); });
      v.addEventListener('ended', function () { empiler('video', { geste: 'fin', nom: nom }); });
      v.addEventListener('timeupdate', function () {
        if (!v.duration || v.autoplay) return;
        var p = Math.floor(100 * v.currentTime / v.duration / 25) * 25;
        if (p > 0 && !paliers[p]) { paliers[p] = 1; empiler('video', { geste: 'progression', nom: nom, palier: p }); }
      });
    })(vs[i], i);
  }
  function surCopie() {
    var s = String(window.getSelection ? window.getSelection() : '');
    empiler('copie', { lg: s.length, tel: /(\+33|0)\s?[1-9](?:[\s.-]?\d{2}){4}/.test(s) ? 1 : 0, sect: sectionDe(document.activeElement) });
  }

  // ── panier : on écoute les appels du thème à /cart/*.js ───────────────────────────────────────
  function brancherPanier() {
    var noter = function (url, corps, statut) {
      var m = String(url).match(/\/cart\/(add|change|update|clear)(?:\.js)?/); if (!m) return;
      var d = { action: m[1], statut: statut };
      try {
        var b = typeof corps === 'string' ? (corps.trim().charAt(0) === '{' ? JSON.parse(corps) : Object.fromEntries(new URLSearchParams(corps))) : null;
        if (b) {
          var items = b.items || (b.id ? [{ id: b.id, quantity: b.quantity }] : null);
          if (items) d.articles = items.slice(0, 12).map(function (x) { return { id: String(x.id || x.variant_id || ''), q: +x.quantity || 1 }; });
          if (b.line !== undefined) { d.ligne = b.line; d.q = b.quantity; }
        }
      } catch (e) {}
      empiler('panier', d);
    };
    if (window.fetch) {
      var f0 = window.fetch;
      window.fetch = function (u, o) {
        var url = typeof u === 'string' ? u : (u && u.url) || '';
        var p = f0.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function (r) { noter(url, o && o.body, r.status); }, function () { noter(url, o && o.body, 0); });
        return p;
      };
    }
    var X = window.XMLHttpRequest && XMLHttpRequest.prototype;
    if (X) {
      var open0 = X.open, send0 = X.send;
      X.open = function (m, u) { this.__laeU = u; return open0.apply(this, arguments); };
      X.send = function (b) { var x = this; if (/\/cart\/(add|change|update|clear)/.test(x.__laeU || '')) x.addEventListener('loadend', function () { noter(x.__laeU, b, x.status); }); return send0.apply(this, arguments); };
    }
    document.addEventListener('submit', function (ev) {
      var f = ev.target; if (f && /\/cart\/add/.test(f.getAttribute('action') || '')) {
        var id = f.querySelector('[name=id]'); empiler('panier', { action: 'add', formulaire: 1, articles: id ? [{ id: String(id.value), q: 1 }] : [] });
      }
    }, true);
  }

  // ── erreurs JavaScript, Web Vitals réels ──────────────────────────────────────────────────────
  var nErreurs = 0, vus = {};
  function surErreur(msg, src, ligne, col) {
    if (nErreurs >= 20) return;
    var k = msg + '|' + src + '|' + ligne; if (vus[k]) return; vus[k] = 1; nErreurs++;
    empiler('erreur', { msg: String(msg).slice(0, 300), src: String(src || '').split('?')[0].slice(-120), ligne: ligne || 0, col: col || 0 });
  }
  var vit = { lcp: null, cls: 0, inp: null, fcp: null };
  function observerVitals() {
    var po = function (type, cb, opts) { try { new PerformanceObserver(function (l) { l.getEntries().forEach(cb); }).observe(Object.assign({ type: type, buffered: true }, opts || {})); } catch (e) {} };
    po('largest-contentful-paint', function (e) { vit.lcp = Math.round(e.startTime); vit.lcp_el = (e.element && selecteur(e.element)) || ''; });
    po('layout-shift', function (e) { if (!e.hadRecentInput) vit.cls = +(vit.cls + e.value).toFixed(4); });
    po('paint', function (e) { if (e.name === 'first-contentful-paint') vit.fcp = Math.round(e.startTime); });
    po('event', function (e) { if (e.interactionId && (vit.inp === null || e.duration > vit.inp)) vit.inp = Math.round(e.duration); }, { durationThreshold: 40 });
  }

  // ── enregistrement de la visite (rrweb) pour le replay ────────────────────────────────────────
  var rrFile = [], rrSeq = 0, rrMin = null, rrStop = null;
  function b64(buf) { var s = '', a = new Uint8Array(buf); for (var i = 0; i < a.length; i += 0x8000) s += String.fromCharCode.apply(null, a.subarray(i, i + 0x8000)); return btoa(s); }
  /* 🛑 01/10 — un GROS morceau (≥ 60 Ko : la photo d'une page lourde) part par un envoi ordinaire, que le navigateur
     ANNULE si le visiteur change de page pendant l'envoi (seuls les envois ≤ 64 Ko survivent au départ). Mesuré : sur le
     configurateur, quitté en 5 s, une fois sur deux la vue n'avait aucun replay. Ces morceaux-là sont donc MIS DE CÔTÉ dans
     le navigateur du visiteur (après son accord seulement), effacés dès que le récepteur répond, et RENVOYÉS par la page
     suivante si l'envoi a été coupé. Les petits morceaux partent en `keepalive`, qui survit au départ : jamais en double. */
  var RP = 'lae_rp_';
  function garderReplay(cle, corps) { try { if (LS && corps.length >= 60000 && corps.length < 1500000) LS.setItem(cle, JSON.stringify({ t: Date.now(), c: corps })); } catch (e) { /* stockage plein : tant pis */ } }
  function oublierReplay(cle) { try { LS && LS.removeItem(cle); } catch (e) {} }
  function clesReplay() { var k = []; try { for (var i = 0; i < LS.length; i++) { var x = LS.key(i); if (x && x.indexOf(RP) === 0) k.push(x); } } catch (e) {} return k; }
  function renvoyerReplays() {
    if (!LS) return;
    clesReplay().forEach(function (k) {
      var o = null; try { o = JSON.parse(LS.getItem(k)); } catch (e) {}
      if (!o || !o.c || Date.now() - o.t > 7 * 864e5) { oublierReplay(k); return; }          // plus d'une semaine : abandonné
      fetch(C.url + '/r', { method: 'POST', body: o.c, mode: 'cors', headers: { 'Content-Type': 'text/plain' }, credentials: 'omit' })
        .then(function (r) { if (r.ok || r.status === 400 || r.status === 413) oublierReplay(k); }).catch(function () {});
    });
  }
  function envoyerReplay(fin) {
    clearTimeout(rrMin); rrMin = null;
    if (!rrFile.length) return;
    var evs = rrFile.splice(0, rrFile.length), seq = rrSeq++;
    var brut = JSON.stringify(evs), base = { s: session, vue: vue, seq: seq, ts0: evs[0].timestamp, ts1: evs[evs.length - 1].timestamp, n: evs.length };
    var cle = RP + session + '_' + vue + '_' + seq;
    var poster = function (corps) {
      garderReplay(cle, corps);            // ≥ 60 Ko seulement : la page suivante le renverra si cet envoi est coupé
      try {
        if (fin && navigator.sendBeacon && corps.length < 60000) navigator.sendBeacon(C.url + '/r', new Blob([corps], { type: 'text/plain' }));
        else fetch(C.url + '/r', { method: 'POST', body: corps, keepalive: corps.length < 60000, mode: 'cors', headers: { 'Content-Type': 'text/plain' }, credentials: 'omit' })
          .then(function (r) { if (r.ok) oublierReplay(cle); }).catch(function () {});
      } catch (e) {}
    };
    if (window.CompressionStream && !fin) {
      new Response(new Blob([brut]).stream().pipeThrough(new CompressionStream('gzip'))).arrayBuffer().then(function (buf) {
        poster(JSON.stringify(Object.assign(base, { gz: 1, c: b64(buf) })));
      }).catch(function () { poster(JSON.stringify(Object.assign(base, { gz: 0, c: brut }))); });
    } else poster(JSON.stringify(Object.assign(base, { gz: 0, c: brut })));
  }
  function demarrerReplay() {
    if (!C.rrweb || C.replay === false || rrStop) return;
    var lancer = function () {
      if (!actif || !window.rrwebRecord) return;
      var rec = window.rrwebRecord.record || window.rrwebRecord.default || window.rrwebRecord;
      try {
        rrStop = rec({
          emit: function (e) {
            rrFile.push(e);
            /* 🛑 01/10 : la « photo » de la page (type 2) part AUSSITÔT, compressée, pendant que la page vit.
               Elle attendait 10 s : un visiteur parti avant l'emportait avec lui, et la vue n'avait pas de replay. */
            if (e && e.type === 2) { setTimeout(function () { envoyerReplay(false); }, 0); return; }
            if (rrFile.length >= 150) envoyerReplay(false);
            else if (!rrMin) rrMin = setTimeout(function () { envoyerReplay(false); }, 3000);
          },
          maskAllInputs: true,                    // 🛑 aucune saisie n'est enregistrée
          maskInputOptions: { password: true, email: true, tel: true, text: true, textarea: true, number: true, search: true },
          blockClass: 'lae-nomesure', maskTextClass: 'lae-masque',
          recordCanvas: false, collectFonts: false, inlineImages: false, inlineStylesheet: true,
          sampling: { mousemove: 60, mouseInteraction: true, scroll: 150, media: 800, input: 'last' },
          slimDOMOptions: 'all',
        }) || null;
      } catch (e) { rrStop = null; }
    };
    var charger = function () {
      if (window.rrwebRecord) return lancer();
      var s = document.createElement('script'); s.src = C.rrweb; s.async = true; s.onload = lancer; document.head.appendChild(s);
    };
    /* 01/10 : au plus 0,3 s après le consentement (4 s avant) — l'enregistreur est déjà téléchargé (préchargement
       ci-dessus) : une page quittée vite, même lourde (configurateur, 3D), doit avoir sa photo et donc son replay. */
    if ('requestIdleCallback' in window) requestIdleCallback(charger, { timeout: 300 }); else setTimeout(charger, 0);
  }

  // ── cycle de vie ──────────────────────────────────────────────────────────────────────────────
  // Le bilan de la vue (durée, défilement, sections, vitals) part de trois façons, pour ne jamais dépendre du seul
  // dernier instant : un « etat » toutes les 15 s tant que l'onglet est visible, la « sortie » dès que l'onglet passe
  // en arrière-plan (le moment le plus fiable, surtout sur mobile), et la « sortie » au pagehide si elle manque.
  // Le tableau de bord retient le DERNIER bilan de chaque vue.
  var sortieFaite = false, nClicsTotal = 0, dernierEtat = '';
  function bilan() {
    return { duree: Math.round(perfNow()), defil_max: defil.max, defil_px: defil.maxPx, doc_h: document.documentElement.scrollHeight,
      sections: bilanSections(), vitals: vit, clics: nClicsTotal, i3d: interactions3d, t3d: debut3d ? Math.round(perfNow() - debut3d) : 0 };
  }
  function etat(force) {
    if (!actif || (document.visibilityState !== 'visible' && !force)) return;
    var b = bilan(), cle = b.defil_max + '|' + b.clics + '|' + b.sections.map(function (s) { return Math.round(s.vis / 5000); }).join(',');
    if (cle === dernierEtat && !force) return;
    dernierEtat = cle; empiler('etat', b);
    if (force) vider(false);     // envoi IMMÉDIAT, avant que la page ne commence à se fermer
  }
  function sortie() {
    if (!actif || sortieFaite) return;
    sortieFaite = true;
    empiler('sortie', bilan());
    vider(true); envoyerReplay(true);
  }
  function demarrer() {
    if (actif) return;
    actif = true;
    var neuve = identifiants();
    var ctx = contextePage(); ctx.nouvelle_session = neuve ? 1 : 0; ctx.retour = lsGet('lae_deja') ? 1 : 0; lsSet('lae_deja', '1');
    empiler('page', ctx);
    observerVitals(); observerSections(); brancherVideos(); brancherPanier();
    mesurerDefilement();
    var dSc = null;
    addEventListener('scroll', function () { dernierGeste = perfNow(); if (!dSc) dSc = setTimeout(function () { dSc = null; mesurerDefilement(); }, 200); }, { passive: true });
    document.addEventListener('click', surClic, true);
    document.addEventListener('pointerdown', surPointer, { capture: true, passive: true });
    document.addEventListener('keydown', function () { dernierGeste = perfNow(); }, { capture: true, passive: true });
    document.addEventListener('focusin', surFocus, true);
    document.addEventListener('focusout', surBlur, true);
    document.addEventListener('submit', surSubmit, true);
    document.addEventListener('copy', surCopie, true);
    ['lae:aller', 'lae:config', 'lae:show3d'].forEach(function (n) { document.addEventListener(n, surConfig, true); window.addEventListener(n, surConfig, true); });
    addEventListener('error', function (e) { if (e.message) surErreur(e.message, e.filename, e.lineno, e.colno); }, true);
    addEventListener('unhandledrejection', function (e) { surErreur('promesse rejetée : ' + (e.reason && (e.reason.message || e.reason) || ''), '', 0, 0); });
    document.addEventListener('visibilitychange', function () {
      tickSections();
      empiler('visibilite', { etat: document.visibilityState });
      if (document.visibilityState === 'hidden') { sortie(); } else { sortieFaite = false; toucherSession(); }
    });
    addEventListener('pagehide', sortie);
    setInterval(etat, 15000);
    setInterval(function () { if (document.visibilityState === 'visible') { toucherSession(); brancherVideos(); } }, 20000);
    demarrerReplay();
    renvoyerReplays();     // les gros morceaux d'une page précédente dont l'envoi a été coupé
  }
  function arreter() {
    actif = false; file = []; rrFile = [];
    clesReplay().forEach(oublierReplay);   // accord retiré : rien ne reste en attente dans le navigateur
    try { rrStop && rrStop(); } catch (e) {}
    rrStop = null;
  }

  // ── consentement (API Customer Privacy de Shopify) ────────────────────────────────────────────
  function autorise() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
  }
  function evaluer() { if (autorise() || (mode_test && C.test_consent)) demarrer(); else if (actif) arreter(); }
  document.addEventListener('visitorConsentCollected', function (e) {
    var d = e && e.detail || {};
    if (d.analyticsAllowed) demarrer(); else arreter();
  });
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) evaluer(); });
  } else evaluer();
})();
